import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { globalStateSelector } from 'store/selector';
import { CallBreakTheme } from 'modules/theme'
import { messageAction, globalAction } from 'store/action';
export class CallBreak extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
    };
  }

  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage('message-processor', message);
  }

  onLoadMore = () => {
    const { configProcessor } = this.props;
    this.setState(
      (prevState) => ({ page: prevState.page + 1 }),
      () => {
        configProcessor('pauseList', { page_no: this.state.page });
      }
    );
  };

  render() {
    const { breakList, updatePause } = this.props
    return (
      <CallBreakTheme
        onLoadMore={this.onLoadMore}
        breakList={breakList}
        onSelect={( data )=>{
          let message = {
            type: 'stateHandler',
            state: "break",
            subState: data.name,
            stateInfo: {
              id : data._id,
              name : data.name
            }
          };
          this.sendMessage(message);
          updatePause({ key: 'breakName', value: data.name }  )
        }}
      />
    )
  }
}


const stateToProps = state => ({
  breakList: globalStateSelector.getDynamic(state, { key: 'breakList' })
});

const dispatchToProps = dispatch => ({
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  updatePause( data ){
    dispatch(globalAction.dynamicUpdate({data}));
  },
  configProcessor: (type, data) => {
    dispatch(messageAction.configProcessor(type, data));
  }
});
export default connect(stateToProps, dispatchToProps)(CallBreak);


// WEBPACK FOOTER //
// src/dialpad/components/layout/CallBreak.js